import React from 'react';
import { CLIENT_VERSION } from '../../config';
import { getText } from '../utils/functions';

function Footer({
	data,
	colors,
	translate,

	/* OPTIONAL PROPS */
	classNameFOOTER = `flex font-lato font-semibold
		flex-col gap-y-4 text-xs justify-center p-4 md:p-0
		md:flex-row md:justify-center md:text-base md:px-9`,
	classNameCOPYRIGHT = 'flex space-x-2 items-center justify-center md:w-max md:pt-6 md:pb-5',
	classNameLINKS = 'flex justify-between md:items-center md:h-auto',
	classNameMaxWidthDiv = 'md:w-full max-w-screen-2xl md:m-auto md:flex justify-between',
}) {
	/* Get year for the copyright */
	const year = new Date().getFullYear();

	/* Default values for the styles */
	const defaultStyleFOOTER = {
		backgroundColor: colors?.light,
		color: colors?.text,
		transition: 'all 100ms ease-in',
	};
	return <footer id='Footer'
		className={classNameFOOTER}
		style={defaultStyleFOOTER}
	>
		<div
			className={classNameMaxWidthDiv}
		>
			{/* COPYRIGHT */}
			{data?.copyright?.isActive
				&& <div className={classNameCOPYRIGHT}>
					<div
						dangerouslySetInnerHTML={{ __html: `Copyright &copy ${year}` }}
					/>
					<span>
						{`v${CLIENT_VERSION} - `}
						<a
							href={data?.copyright?.value}
							rel="noreferrer noopener"
							target='blank'
						>
							{getText(data?.copyright, translate)}
						</a>
					</span>
				</div>}
			{/* LINKS */}
			<div className={classNameLINKS}>
				{Object.values(data?.links || [])?.filter(link => link.isActive)
					.map(link => <Link
						link={link}
						colors={colors}
						translate={translate}
						key={Object.values(data?.links).indexOf(link)}
					/>)
				}
			</div>
		</div>
	</footer>;
}

function Link({
	link,
	colors,
	translate,
}) {
	/* Variable that checks if any point of the component is being hovered so style can be applied to the Box */
	const [hover, setHover] = React.useState(false);

	/* Default values for the styles */
	const defaultStyleLINK = {
		backgroundColor: hover ? colors?.primary : colors?.light,
		color: hover ? colors?.light : colors?.text,
		transition: 'all 200ms ease-in',
	};

	/* Mouseover Styling */
	const onMouseOver = () => setHover(true);
	const onMouseLeave = () => setHover(false);

	return <a
		className = {`h-full flex items-center pb-2 md:pb-0 md:px-4
				${link.key === 'SOPORTE' ? 'hidden sm:flex' : ''}`
		}
		style={defaultStyleLINK}
		onMouseOver={onMouseOver}
		onMouseLeave={onMouseLeave}
		href={link.value}
		rel='noreferrer'
		target='_blank'
	>
		{(getText(link, translate)) }
	</a>;
}

export default Footer;
